import { type PropsWithChildren } from "react";

import { DOM_IDS } from "../defaults";

export const Body = ({ children }: Readonly<PropsWithChildren>) => (
  <div
    id={DOM_IDS.dockBody}
    data-testid="circle-ai-shell-dock-body"
    className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto"
  >
    {children}
  </div>
);

Body.displayName = "CircleAIAppShell.Layout.Dock.Body";
